import { z } from 'zod';
import { PLAIN_NAME_MESSAGE, plainName } from './json.js';
import { Industry } from './controls.js';
/**
 * Any company can come on its own (decision 0034): after signing up, the person sets up their business,
 * which becomes a tenant of its own with its first Cyber Check started.
 */
export const BusinessProfile = z.strictObject({
    industry: Industry,
    /** People working for the business, part-time included: the Cyber Check's first question. */
    employees: z.coerce.number().int().min(1, 'At least 1').max(100_000, 'At most 100,000'),
});
export const SetUpBusiness = z.strictObject({
    name: z
        .string()
        .trim()
        .min(2, 'Enter the business’s name')
        .max(200, 'Use at most 200 characters')
        .refine(plainName, PLAIN_NAME_MESSAGE),
    ...BusinessProfile.shape,
    /** The journeys published so far are Malaysian. */
    country: z.literal('MY').default('MY'),
});
/** The title of a business's own check: "Cyber Check 2026". */
export const checkTitle = (date = new Date()) => `Cyber Check ${date.getFullYear()}`;
//# sourceMappingURL=onboarding.js.map